import type { TJwtPayload, TAuthUser } from "./jwt.types";

export const parseJwt = (token: string): TJwtPayload | null => {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const payload = parts[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "==".slice(0, (4 - (base64.length % 4)) % 4);

    const decoded = globalThis.atob(padded);

    return JSON.parse(decoded) as TJwtPayload;
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  const payload = parseJwt(token);
  if (!payload?.exp) return true;

  const now = Math.floor(Date.now() / 1000);
  return payload.exp <= now;
};

export const isTokenValid = (token: string | null): boolean => {
  if (!token) return false;
  return !isTokenExpired(token);
};

export const getUserFromToken = (token: string): TAuthUser | null => {
  const payload = parseJwt(token);
  if (!payload) return null;

  return {
    email: payload.email || "",
    name: payload.name || "",
    sub: payload.sub || "",
    emailVerified: payload.email_verified || false,
    raw: payload as unknown as Record<string, unknown>,
  };
};

export const isTemporaryUserEmail = (email: string): boolean => {
  return email.includes("vender_deslogado");
};
